import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mergeCommit: {
    id: 'frontbucket.mergeStrategies.mergeCommit',
    description: 'Text for the merge commit strategy label',
    defaultMessage: 'Merge commit',
  },
  squash: {
    id: 'frontbucket.mergeStrategies.squash',
    description: 'Text for the squash strategy label',
    defaultMessage: 'Squash',
  },
  fastForward: {
    id: 'frontbucket.mergeStrategies.fastForward',
    description: 'Text for the fast forward strategy label',
    defaultMessage: 'Fast forward',
  },
  squashFastForward: {
    id: 'frontbucket.mergeStrategies.squashFastForward',
    description: 'Text for the squash, fast forward strategy label',
    defaultMessage: 'Squash, fast forward',
  },
  rebaseFastForward: {
    id: 'frontbucket.mergeStrategies.rebaseFastForward',
    description: 'Text for the rebase, fast forward strategy label',
    defaultMessage: 'Rebase, fast forward',
  },
  rebaseMerge: {
    id: 'frontbucket.mergeStrategies.rebaseMerge',
    description: 'Text for the rebase, merge strategy label',
    defaultMessage: 'Rebase, merge',
  },
});
